import { postWithAuth, getWithAuth, putWithAuth } from '../../Basic/HttpService';

export const getAllCustomerDashboard = async () => {
    let res = await getWithAuth(`customerDashboard`);
    return res;
};
